module.exports = __webpack_public_path__ + "media/img/apple-icon-3414a85148bec926df75eb0ea7123ce6.png";